// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3YUbI","rootCenter":"LoadMoreObserver_rootCenter__2xWrK","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__33Ybl"};